import { BaseModel } from '~/models/baseModel';

export class EntityCreditCardModel extends BaseModel {
    public guid:string;
    public entityId:number;
    public expiry:string;
    public pan:string;
    public token:string;
}